import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const clx = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

/**
 * Get headers in a client-side environment.
 * In the browser, we can access user-agent from navigator.
 * Custom headers like x-client may be passed via meta tags or other means.
 */
export const getHeaders = (): Headers => {
  const headers = new Headers();

  // Get user-agent from navigator.
  if (typeof navigator !== 'undefined' && navigator.userAgent) {
    headers.set('user-agent', navigator.userAgent);
  }

  // Get x-client from meta tag if available.
  const xClientMeta =
    typeof document !== 'undefined'
      ? document.querySelector('meta[name="x-client"]')?.getAttribute('content')
      : null;

  if (xClientMeta) {
    headers.set('x-client', xClientMeta);
  }

  return headers;
};
